
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.583 19.526a1.76 1.76 0 00-.972.293 1.725 1.725 0 00-.265 2.672 1.754 1.754 0 001.907.377c.32-.132.593-.354.785-.64a1.727 1.727 0 00-.217-2.193 1.757 1.757 0 00-1.238-.509zm12.25-3.473h-14c-.31 0-.606-.122-.825-.34a1.154 1.154 0 010-1.637c.22-.217.516-.34.825-.34h9.907a3.532 3.532 0 002.105-.703 3.488 3.488 0 001.26-1.816l1.85-6.425a1.149 1.149 0 00-.19-1.015 1.164 1.164 0 00-.932-.461H7.53a3.484 3.484 0 00-1.275-1.674A3.526 3.526 0 004.242 1H3.167c-.31 0-.606.122-.825.34a1.154 1.154 0 000 1.637c.219.217.515.339.825.339h1.075c.253 0 .5.083.701.234.202.152.35.364.42.605l.182.631v.006l1.914 6.649c-.89.095-1.71.525-2.291 1.202a3.457 3.457 0 00.258 4.773c.65.611 1.512.952 2.407.952h14c.31 0 .607-.122.825-.339a1.154 1.154 0 000-1.637 1.171 1.171 0 00-.825-.34zM20.287 5.632l-1.425 4.949c-.07.242-.218.454-.42.606a1.178 1.178 0 01-.702.234H9.88l-1.666-5.79h12.073zm-1.37 13.894a1.76 1.76 0 00-.973.293 1.725 1.725 0 00-.265 2.672 1.754 1.754 0 001.907.377c.32-.132.593-.354.786-.64a1.727 1.727 0 00-.218-2.193 1.757 1.757 0 00-1.237-.509z","fill":"currentColor"}})])
          )
        }
      }
    